import React, { useState } from 'react';
import { FileText, FileStack } from 'lucide-react';
import { SWMSPage } from './SWMSPage';
import SafetyPaperworkPage from './SafetyPaperworkPage';

type Tab = 'swms' | 'safety-paperwork';

const TABS: { id: Tab; label: string; icon: React.ComponentType<{ className?: string }>; description: string }[] = [
  { id: 'swms',             label: 'SWMS',             icon: FileText,  description: 'Create and manage Safe Work Method Statements. Build SWMS documents, assign workers, and capture digital signatures.' },
  { id: 'safety-paperwork', label: 'Safety Paperwork', icon: FileStack, description: 'Access and manage all other safety documentation including asbestos removal control plans, demolition SWMS, and other site safety forms.' },
];

export const SWMSTabPage: React.FC = () => {
  const [active, setActive] = useState<Tab>('swms');

  return (
    <div className="space-y-0">
      <div className="bg-white border-b border-gray-200 -mx-6 px-6 mb-6">
        <nav className="flex gap-1" aria-label="SWMS sections">
          {TABS.map(tab => {
            const Icon = tab.icon;
            const isActive = active === tab.id;
            return (
              <div key={tab.id} className="relative group">
                <button
                  onClick={() => setActive(tab.id)}
                  className={`flex items-center gap-2 px-4 py-3.5 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${
                    isActive
                      ? 'border-orange-500 text-orange-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  <Icon className="h-4 w-4" />
                  {tab.label}
                </button>
                <div className="pointer-events-none absolute left-1/2 -translate-x-1/2 top-full mt-2 z-50 hidden group-hover:block">
                  <div className="bg-gray-900 text-white text-xs rounded-lg px-3 py-2 shadow-xl w-56 leading-snug text-center">
                    {tab.description}
                    <div className="absolute left-1/2 -translate-x-1/2 bottom-full border-4 border-transparent border-b-gray-900" />
                  </div>
                </div>
              </div>
            );
          })}
        </nav>
      </div>

      <div className={active === 'swms'             ? '' : 'hidden'}><SWMSPage /></div>
      <div className={active === 'safety-paperwork' ? '' : 'hidden'}><SafetyPaperworkPage /></div>
    </div>
  );
};
